exports.auditEntityEndpoint = (state, payload) => (
    `${state.config.apiUrl}/v1/audits/entity/${payload.entityId}`
);



// WEBPACK FOOTER //
// ./src/services/audits/selectors.js